"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/DropdownParticipantsPicker/EntityAvatar.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _Props = require('web/components/Form/Props');






var _Avatar = require('web/components/Avatar'); var _Avatar2 = _interopRequireDefault(_Avatar);











// SAFETY: the legacy entity avatar is a loose bag of keys: each avatar reads only the
// keys it needs, and which one applies is decided at runtime from the entity
// type or from the keys present. The cast drops the branded key types.
const asAvatar = (c) => c 

const entityAvatarsMap = {
  [_Props.ENTITY_TYPES.USER]: asAvatar(_Avatar.UserAvatar),
  [_Props.ENTITY_TYPES.NEWUSER]: asAvatar(_Avatar.UserAvatar),
  [_Props.ENTITY_TYPES.TEAM]: asAvatar(_Avatar.TeamAvatar),
  [_Props.ENTITY_TYPES.ORG]: asAvatar(_Avatar.OrgAvatar),
  [_Props.ENTITY_TYPES.PATIENT]: asAvatar(_Avatar.PatientAvatar),
  [_Props.ENTITY_TYPES.NEWPATIENT]: asAvatar(_Avatar.PatientAvatar),
  [_Props.ENTITY_TYPES.ADD]: asAvatar(_Avatar.AddAvatar),
}

const guessAvatar = (avatar) => {
  if (avatar.userKey) return asAvatar(_Avatar.UserAvatar)
  if (avatar.teamKey) return asAvatar(_Avatar.TeamAvatar)
  if (avatar.patientKey) return asAvatar(_Avatar.PatientAvatar)
  if (avatar.orgKey) return asAvatar(_Avatar.OrgAvatar)
  if (avatar.isAdd) return asAvatar(_Avatar.AddAvatar)
  return asAvatar(_Avatar2.default)
}

const EntityAvatar = ({ avatar, entityType, size }) => {
  const Avatar = entityType
    ? entityAvatarsMap[entityType] || asAvatar(_Avatar2.default)
    // Let's take a guess...
    : guessAvatar(avatar)

  return _react2.default.createElement(Avatar, { ...avatar, size: size, __self: this, __source: {fileName: _jsxFileName, lineNumber: 51}} )
}

exports. default = EntityAvatar
